import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  completeMasterclassTraining,
  completeTraining,
  getAllUserLevels,
  getAllUserMasterclassTrainings,
  getAllUserTrainings,
  getAllUserTrainingsWithTitle
} from "../../api/trainingApi";

// Async thunk for fetching all meals with pagination
export const getCurrentUserLevels = createAsyncThunk(
  "training/getAllUserLevels",
  async (date, thunkAPI) => {
    try {
      const response = await getAllUserLevels(date);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getCurrentUserTrainings = createAsyncThunk(
  "training/getCurrentUserTrainings",
  async (levelId, thunkAPI) => {
    try {
      const response = await getAllUserTrainings(levelId);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const completeTrainings = createAsyncThunk(
  "training/completeTrainings",
  async ({ date, levelId, trainingDayId }, thunkAPI) => {
    try {
      const response = await completeTraining(date, levelId, trainingDayId);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const completeMasterclassTrainingDay = createAsyncThunk(
  "training/completeMasterclassTrainingDay",
  async ({ date, levelId, trainingDayId }, thunkAPI) => {
    try {
      const response = await completeMasterclassTraining(
        date,
        levelId,
        trainingDayId
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getCurrentUserAllTrainings = createAsyncThunk(
  "training/getCurrentUserAllTrainings",
  async (date, thunkAPI) => {
    try {
      const response = await getAllUserTrainingsWithTitle(date);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getCurrentUserMasterclassTrainings = createAsyncThunk(
  "training/getCurrentUserMasterclassTrainings",
  async (date, thunkAPI) => {
    try {
      const response = await getAllUserMasterclassTrainings(date);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Initial state
const initialState = {
  allMasterclassTrainings: [],
  masterclassLoading: false,
  masterclassError: null,
  allTrainings: [],
  allTrainingsWithTitle: [],
  availableLevels: [], // holds the availableLevels data
  selectedLevel: null,
  loading: false, // loading state for getCurrentUserLevels
  error: null // error state
};

const trainingSlice = createSlice({
  name: "training",
  initialState,
  reducers: {
    updateSelectedLevel: (state, action) => {
      state.selectedLevel = action.payload;
    },
    updateTrainingById: (state, action) => {
      const { id, updates } = action.payload;
      const index = state.allTrainings.findIndex(
        (item) => item.trainingId === id
      );
      if (index !== -1) {
        state.allTrainings[index] = {
          ...state.allTrainings[index],
          ...updates
        };
      }
    },
    updateMasterclassTrainingById: (state, action) => {
      const { id, updates } = action.payload;
      Object.entries(state.allMasterclassTrainings?.trainings).forEach(
        ([sectionType, trainings]) => {
          const index = trainings.findIndex((item) => item.trainingId === id);
          if (index !== -1) {
            // Update the specific training
            trainings[index] = {
              ...trainings[index],
              ...updates
            };
          }
        }
      );
    },
    updateTrainingProgressById: (state, action) => {
      const { id, updates } = action.payload;
      for (let level of state.allTrainingsWithTitle) {
        const index = level.trainings.findIndex((t) => t.trainingId === id);
        if (index !== -1) {
          level.trainings[index] = {
            ...level.trainings[index],
            ...updates
          };
          break;
        }
      }
    },

    updatePercentage: (state, action) => {
      const { id, updates } = action.payload;
      const index = state.availableLevels.findIndex(
        (item) => item.levelId === id
      );
      if (index !== -1) {
        state.availableLevels[index] = {
          ...state.availableLevels[index],
          ...updates
        };
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCurrentUserLevels.pending, (state) => {
        // state.loading = true;
      })
      .addCase(getCurrentUserLevels.fulfilled, (state, action) => {
        // state.loading = false;
        state.availableLevels = action.payload.levels; // assuming response has meals data
      })
      .addCase(getCurrentUserLevels.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCurrentUserTrainings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCurrentUserTrainings.fulfilled, (state, action) => {
        state.loading = false;
        state.allTrainings = action.payload.trainings; // assuming response has meals data
      })
      .addCase(getCurrentUserTrainings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCurrentUserAllTrainings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCurrentUserAllTrainings.fulfilled, (state, action) => {
        state.loading = false;
        state.allTrainingsWithTitle = action.payload.trainings; // assuming response has meals data
      })
      .addCase(getCurrentUserAllTrainings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCurrentUserMasterclassTrainings.pending, (state) => {
        state.masterclassLoading = true;
      })
      .addCase(
        getCurrentUserMasterclassTrainings.fulfilled,
        (state, action) => {
          state.masterclassLoading = false;
          state.allMasterclassTrainings = action.payload.masterclass; // assuming response has meals data
        }
      )
      .addCase(getCurrentUserMasterclassTrainings.rejected, (state, action) => {
        state.masterclassLoading = false;
        state.masterclassError = action.payload;
      });
  }
});

export const {
  updateTrainingById,
  updateSelectedLevel,
  updateMasterclassTrainingById,
  updateTrainingProgressById,
  updatePercentage
} = trainingSlice.actions;

export default trainingSlice.reducer;
